module.exports = __webpack_public_path__ + "img/error-illustration.9880ebec.svg";